/**
 * Dose display card component
 */

import React from 'react';
import { View, Text, StyleSheet } from 'react-native';

interface DoseCardProps {
  doseMicroSv: number;
  label?: string;
}

export function DoseCard({ doseMicroSv, label = 'Dose' }: DoseCardProps) {
  const doseMsv = (doseMicroSv / 1000).toFixed(2);

  return (
    <View style={styles.card}>
      <Text style={styles.label}>{label}</Text>
      <Text style={styles.value}>{doseMsv} mSv</Text>
      <Text style={styles.unit}>({doseMicroSv} µSv)</Text>
    </View>
  );
}

const styles = StyleSheet.create({
  card: {
    padding: 16,
    backgroundColor: '#f5f5f5',
    borderRadius: 8,
    borderWidth: 1,
    borderColor: '#e0e0e0',
  },
  label: { fontSize: 14, color: '#666', marginBottom: 4 },
  value: { fontSize: 24, fontWeight: '600' },
  unit: { fontSize: 12, color: '#888', marginTop: 4 },
});
